"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0967 23V11.7683H7V8.2485H10.0967V5.65288C10.0967 2.64036 11.9708 1 14.7091 1C16.0209 1 17.1475 1.09621 17.4762 1.13896V4.28753L15.5774 4.2885C14.0884 4.2885 13.8003 4.98332 13.8003 6.00175V8.24947H17.3515L16.8891 11.7693H13.8003V23H10.0967Z", fill: "currentColor" }));
